import { ArticleBody, ArticleCallout } from "./Article.elements";

export const ResetPasswordArticle = () => (
  <ArticleBody>
    <h3>Resetting your password, step by step</h3>
    <ol>
      <li>
        On the sign-in page press <strong>Forgot Password?</strong>.
      </li>
      <li>
        Type the e-mail address your Clippn account uses — the one you sign in with. A typo here is the most
        common reason no mail ever arrives, so check it before pressing <strong>Submit</strong>.
      </li>
      <li>
        Open your inbox and look for an e-mail called <strong>“Clippn Password Reset”</strong>. It usually
        arrives within a minute or two.
      </li>
      <li>
        Press <strong>Set new password</strong> in the e-mail, choose a new password, and sign in with it.
      </li>
    </ol>

    <h3>No e-mail? Check Spam first</h3>
    <ArticleCallout>
      In most “I never got the e-mail” cases the message is sitting in <strong>Spam / Junk</strong>. Open the
      Spam folder and search for <strong>Clippn</strong>. If it&apos;s there, mark it as{" "}
      <strong>“Not spam”</strong> — then future e-mails from us (including “upload delivered” notifications)
      land in your inbox.
    </ArticleCallout>
    <ul>
      <li>
        <strong>Gmail:</strong> left menu → <em>More</em> → <em>Spam</em>. Also check <em>All Mail</em> and the{" "}
        <em>Promotions / Updates</em> tabs.
      </li>
      <li>
        <strong>Outlook / corporate mail:</strong> <em>Junk Email</em> folder. Corporate filters sometimes
        quarantine mail — if you find nothing, ask your IT to allow mail from Clippn.
      </li>
      <li>
        Give it a few minutes and refresh. Requesting again within a minute does nothing — repeat requests are
        ignored for a short while to prevent flooding.
      </li>
    </ul>

    <h3>About the link itself</h3>
    <ul>
      <li>
        The link works <strong>once</strong> and expires after a short time. If it says expired or already
        used, just request a fresh one from <strong>Forgot Password?</strong>.
      </li>
      <li>
        If you requested several times, <strong>only the newest e-mail counts</strong> — links from older
        e-mails stop working the moment a new one is sent. Delete the old ones to avoid confusion.
      </li>
    </ul>

    <h3>Still nothing?</h3>
    <ul>
      <li>
        Make sure you typed the <strong>exact address your account is registered with</strong> — a private
        address won&apos;t get mail for an account registered on your work address, and vice versa.
      </li>
      <li>
        If you received an e-mail saying your account is <strong>disabled</strong>, resetting the password
        won&apos;t help — contact your administrator to re-enable the account.
      </li>
      <li>
        As a last resort, ask your administrator or assignment editor — they can trigger a reset for you from
        the Users page.
      </li>
    </ul>
  </ArticleBody>
);
